import {RouteNameEnum} from "@/v2/enumerate/route";

const dashboard = [{
	path: "dashboard",
	name: RouteNameEnum.GLORY_DASHBOARD,
	meta: {
		permission: 61001,
		breadcrumb: []
	},
	component: () => import("@/page/content/glory/dashboard/index.vue"),
}];

export default dashboard;
